import { render, staticRenderFns } from "./Injury.vue?vue&type=template&id=1aa24d54&scoped=true"
import script from "./Injury.vue?vue&type=script&lang=js"
export * from "./Injury.vue?vue&type=script&lang=js"
import style0 from "./Injury.vue?vue&type=style&index=0&id=1aa24d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa24d54",
  null
  
)

export default component.exports